import { render, staticRenderFns } from "./DebtorReceiptListSideMenu.vue?vue&type=template&id=5cba9a61"
import script from "./DebtorReceiptListSideMenu.vue?vue&type=script&lang=js"
export * from "./DebtorReceiptListSideMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports